{
  "_comment": "Empire → modern-country (ISO_A3) membership for the Period 2 Empires quiz (~1450–1750). These are deliberate approximations using modern country boundaries: recognizability over historical-cartographic accuracy. Atlas design philosophy §VIII.2 (Temporal Navigation) is an open question; we are not solving it here.",
  "empires": {
    "ottoman":    ["TUR", "GRC", "BGR", "ALB", "MKD", "BIH", "SRB", "MNE", "ROU", "SYR", "LBN", "ISR", "PSE", "JOR", "IRQ", "EGY", "LBY", "TUN", "DZA", "SAU", "YEM"],
    "safavid":    ["IRN", "AZE", "ARM"],
    "mughal":     ["IND", "PAK", "BGD"],
    "ming_qing":  ["CHN", "MNG"],
    "tokugawa":   ["JPN"],
    "russian":    ["RUS", "BLR", "UKR", "KAZ"],
    "spanish":    ["ESP", "MEX", "GTM", "HND", "SLV", "NIC", "CRI", "PAN", "COL", "VEN", "ECU", "PER", "BOL", "CHL", "ARG", "URY", "PRY", "CUB", "DOM", "PHL"],
    "portuguese": ["PRT", "BRA", "AGO", "MOZ", "GNB", "CPV"],
    "songhai":    ["MLI", "NER", "BFA"]
  },
  "labels": {
    "ottoman":    "Ottoman Empire",
    "safavid":    "Safavid Empire",
    "mughal":     "Mughal Empire",
    "ming_qing":  "Ming / Qing China",
    "tokugawa":   "Tokugawa Japan",
    "russian":    "Russian Empire",
    "spanish":    "Spanish Empire",
    "portuguese": "Portuguese Empire",
    "songhai":    "Songhai Empire"
  }
}
